import styled from "styled-components";
import theme from "../../theme";

export const Container = styled.div`
  @media screen and (max-width: 820px) {
    width: 100%;
  }
  width: 70%;
  padding: 20px 10px;
  .heading {
    padding-bottom: 20px;
    border-bottom: solid 1px #f0f1f3;
    h2 {
      margin-top: 30px;
      font-size: 16px;
      color: #5d6679;
      text-transform: capitalize;
    }
    p {
      margin-top: 5px;
      font-size: 12px;
      color: #989fad;
    }
  }
  .profile {
    margin-top: 20px;
    padding: 5px;
    display: flex;
    gap: 20px;
    margin-bottom: 10px;
    .circled {
      background-color: ${theme.color.brandDeep};
      border-radius: 50%;
      padding: 20px;
    }
    .texts {
      margin-top: 10px;
      h3 {
        font-size: 20px;
        color: #48505e;
        text-transform: capitalize;
      }
      p {
        margin-top: 5px;
        font-size: 12px;
        color: #667085;
      }
    }
  }

  .submit {
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    .submit-buttons {
      display: flex;
      gap: 10px;
      .cancel,
      .change-password {
        padding: 10px 16px;
        height: 40px;
        border: 1px solid #d0d5dd;
        border-radius: 8px;
        font-size: 14px;
        background-color: transparent;
        text-decoration: none;
        cursor: pointer;
        color: #344054;
      }
      .change-password {
        color: #fff;
        border: 1px solid ${theme.color.brandDark};
        background-color: ${theme.color.brandDark};
      }
    }
  }
`;

export const Wrapper = styled.div`
  @media screen and (max-width: 500px) {
    grid-template-columns: repeat(1, 1fr);
    padding: 10px;
    gap: 10px;
    border: none;
  }
  padding: 25px 10px;
  border-bottom: 1px solid #e0e2e6;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  label {
    margin-top: 20px;
    color: #344054;
    font-size: 14px;
  }
  p {
    margin-top: 10px;
    font-size: 14px;
    color: #667085;
  }
  input[type="text"],
  input[type="file"],
  input[type="date"],
  input[type="number"],
  input[type="password"] {
    width: 100%;
    //height: 43px;
    margin-top: 10px;
    border: solid 1px #e0e2e6;
    border-radius: 10px;
    padding: 12px 14px;
    transition: all 0.3s ease;

    &:focus {
      outline: #027f7f;
      border: 1px solid ${theme.color.brandDark};
      background: transparent;
    }
  }
  .eye {
      position: relative;
      left: 199%;
      bottom: 60px;
      cursor: pointer;
    }
  
`;
